import classNames, { Argument } from 'classnames'
import React, { ElementType, ReactNode } from 'react'

import './Selector.scss'

interface Props {
  children: React.ReactNode[]
  optionClassName?: string
  heading?: string
}

export const SelectorOption = <T extends ElementType>({
  children,
  className,
  as,
  ...props
}: {
  children: ReactNode
  className?: Argument
  as?: T
} & React.ComponentPropsWithoutRef<T>) => {
  const As = as ?? 'button'
  return (
    <As {...props} className={classNames('selector__option', className)}>
      {children}
    </As>
  )
}

export const Selector = ({ heading, children }: Props) => {
  return (
    <>
      {heading && <div className="selector__heading">{heading}</div>}
      <div className="selector">{children}</div>
    </>
  )
}
